import React, { createContext, Dispatch, useContext, useEffect, useState } from 'react';
import { ReactNode } from 'react';
import { ListZonesQuery, SubscribeSiteSubscription } from '@/data/data';
import { useWindowDimensions } from 'react-native';
import { Breakpoints } from '@/GlobalStyles';
import { ArrayElement } from '@/utils/typeHelpers';

export type ListType = 'list' | 'card';

type SetStateCallback<S> = (prevState: S) => S;

type ConfigurationContextType = {
  listType: ListType;
  setListType: (state: ListType) => void;
};

// Create the context
const ConfigurationContext = createContext<ConfigurationContextType>({
  listType: 'list',
  setListType: () => {},
});

type ReducedProviderProps = {
  children: ReactNode;
};

// Create the provider component
const ConfigurationContextProvider = (props: ReducedProviderProps) => {
  const [listType, setListType] = useState<ListType>('list');
  const { children } = props;

  const { width } = useWindowDimensions();

  useEffect(() => {
    if (width < Breakpoints.tablet) {
      setListType('card');
    }
  }, [width]);

  return (
    <ConfigurationContext.Provider
      value={{
        listType,
        setListType,
      }}
    >
      {children}
    </ConfigurationContext.Provider>
  );
};

const useConfigurationContext = () => useContext(ConfigurationContext);

// Export the context and provider
export { ConfigurationContext, ConfigurationContextProvider, useConfigurationContext };
